import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/storybox/data/constants';

const initState = {
  currentScreen: SCREENS.PROGRESS,
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        currentScreen: payload,
      };

    case REDUX_ACTIONS.START_STORY:
      return {
        ...state,
        currentScreen: SCREENS.START_VIEW,
      };

    default:
      return state;
  }
};

export default screenReducer;
